export default __webpack_public_path__ + "static/media/info-scooter.cb1c96d9.png";